import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";

import {
  MHeader,
  MTableCell,
  ApiData,
  ActionType,
} from "../Components/table/Table";
import "../Components/table/table.css";

import Header from "../Components/Header/Header";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import QuantityInput from "../Components/QuantityInput/QuantityInput";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Header2 } from "../Components/Header/Header2";
import ModalSupression from "../Components/Modal/ModalSupression";

import { HospitalInterface, VersementInterface } from "../interfaces";
import Pagination from "../Components/pagination/Pagination";
import { rootUrl } from "../constants";
import { CurrentUserContext } from "../App";
import { useReactToPrint } from "react-to-print";
import PaymentModal, { PaymentData } from "../Components/Modal/Paymentmodal";
import PrintList from "../Components/printable_list";
import { generalRefundCategories } from "../utils";
export const titles = [
  { label: "Centre", sortable: true },
  { label: "C.Bud", sortable: true },
  { label: "De", sortable: true },
  { label: "À", sortable: true },
  { label: "Revenue", sortable: true },
];

interface WeekPaymentInterface {
  id: number;
  date: string;
  account: string;
  revenue: number;
  start: string;
  end: string;
}

const VersementNotPayed = () => {
  const componentRef = useRef<HTMLDivElement>(null);
  const [printing, setPrinting] = useState<boolean>(false);

  const [selected, setSelected] = useState<number[]>([]);
  let [currentPage, setCurrentPage] = useState<number>(1);
  const [data, setData] = useState<ApiData<WeekPaymentInterface> | null>(null);
  const [searchedText, setSearchedText] = useState<string>("");
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout>();
  const [quantityTimeouts, setQuantityTimeouts] = useState<
    Map<number, NodeJS.Timeout>
  >(new Map());

  const [hadlingPaymentDate, setHadlingPaymentDate] = useState<string | null>(
    null
  );

  const navigate = useNavigate();
  const [error, setError] = useState(null);

  let currentuserContexxt = useContext(CurrentUserContext);

  const [openedDescription, setOpenDescription] = useState<number | null>(null);

  let token = useContext(CurrentUserContext).currentUserData!.token;

  const [selectedHospitalIndex, setSelectedHospitalIndex] = useState<number>(0);

  const [isPharmacy, setIsPharmacy] = useState<boolean>(false);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState<number>(0);

  function FetchData() {
    setData(null);
    const currentSelectedHospitalId =
      currentuserContexxt.currentUserData!.hospitals[selectedHospitalIndex].id;

    const currentHospital =
      currentuserContexxt.currentUserData!.hospitals[selectedHospitalIndex];

    let refund_category = null;
    if (currentHospital.municipal_tax_data) {
      refund_category = "category_" + (selectedCategoryIndex + 1);
    }
    axios
      .get(rootUrl + "/hospital/" + currentSelectedHospitalId + "/not_payed", {
        params: {
          page: currentPage,
          search: searchedText,
          refund_category: refund_category ?? undefined,

          for_pharmacy: isPharmacy ? "True" : "False",
        },
        headers: {
          Authorization: "Token " + token,
        },
      })
      .then((response: { data: any }) => {
        console.log(
          rootUrl + "/hospital/" + currentSelectedHospitalId + "/not_payed"
        );
        let dd: any[] = response.data.data;
        dd = dd.map((item: any, index: number) => {
          return {
            ...item,
            id: index,
          };
        });
        setData({ ...response.data, data: dd });
      })
      .catch((error: any) => {
        setError(error);
      });
  }

  useEffect(() => {
    FetchData();
  }, [currentPage, selectedHospitalIndex, isPharmacy, selectedCategoryIndex]);

  useEffect(() => {
    clearTimeout(typingTimeout);

    // Set a new timeout to delay the search
    const timeoutId = setTimeout(() => {
      setSelected([]);
      currentPage = 1; //should be updated but not render
      FetchData();
    }, 500);

    setTypingTimeout(timeoutId);

    return () => {
      clearTimeout(typingTimeout);
    };
  }, [searchedText]);
  const handlePrint = useReactToPrint({
    onBeforeGetContent() {
      setPrinting(true);
    },

    content: () => {
      return componentRef.current;
    },
    onAfterPrint: () => {
      setPrinting(false);
    },
  });

  const hospitalName =
    currentuserContexxt.currentUserData?.hospitals[selectedHospitalIndex].name;

  function handlePayment({ data, date }: { data: PaymentData; date: string }) {
    const currentHospitalId =
      currentuserContexxt.currentUserData?.hospitals[selectedHospitalIndex].id;
    const currentHospital =
      currentuserContexxt.currentUserData?.hospitals[selectedHospitalIndex];

    let account = hospitalBankAccount;

    let refund_category = null;

    if (currentHospital!.municipal_tax_data) {
      refund_category = "category_" + (selectedCategoryIndex + 1);
      account = currentHospital!.municipal_tax_data!.accounts[refund_category];
    }
    const newData = {
      amount: data.amount,
      payed_for: date,
      for_pharmacy: isPharmacy,

      refund_category: refund_category ?? undefined,
      account: account,
      quittance_number: data.quittance_number,
      hospital: currentHospitalId,
    };
    axios
      .post(rootUrl + "/hospital/" + currentHospitalId + "/payments", newData, {
        headers: {
          Authorization: "Token " + token,
        },
      })
      .then((response) => {
        alert("Versement effectué avec succès");
        FetchData();
      })
      .catch((error) => {
        alert("Une erreur s'est produite");
        console.error(error);
      });
  }
  let currentHospital =
    currentuserContexxt.currentUserData?.hospitals[selectedHospitalIndex];
  let hospitalBankAccount =
    currentHospital?.municipal_tax_data?.accounts[
      "category_" + (selectedCategoryIndex + 1)
    ] ?? currentHospital?.bank_account;

  return (
    <div className="hopitaux-wrapper">
      {hadlingPaymentDate && data && (
        <PaymentModal
          open={true}
          initalRevenue={
            data.data.find((item) => item.date === hadlingPaymentDate)!.revenue
          }
          onClose={() => {
            setHadlingPaymentDate(null);
          }}
          onConfirmClick={(data) => {
            handlePayment({ data: data, date: hadlingPaymentDate });
          }}
          name={null}
        />
      )}
      <Header title={"Ajouter versement "} />
      <div className="flex gap-x-2 ml-10 font-pop font-medium">
        {currentuserContexxt.currentUserData?.hospitals.map((h, index) => {
          return (
            <button
              onClick={() => {
                setSelectedHospitalIndex(index);
                setSelected([]);

                setIsPharmacy(false);
                setSelectedCategoryIndex(0);
                setCurrentPage(1);
              }}
              className={`font-semibold rounded-sm text-black  p-2 transition-all ${
                selectedHospitalIndex === index ? "bg-[#187498] text-white" : ""
              }`}
            >
              <p>{h.name}</p>
            </button>
          );
        })}
      </div>
      {currentuserContexxt.currentUserData?.hospitals[selectedHospitalIndex]
        .has_pharmacy && (
        <div className="flex flex-col gap-y-2 mt-2 ml-10">
          <hr className="w-96 border-slate-400" />

          <div className="flex gap-x-2 font-pop font-medium ">
            <button
              onClick={() => {
                setIsPharmacy(false);

                setCurrentPage(1);
              }}
              className={`font-semibold rounded-sm text-black  p-2 transition-all ${
                !isPharmacy ? "bg-[#187498] text-white" : ""
              }`}
            >
              <p>Hopital</p>
            </button>
            <button
              onClick={() => {
                setIsPharmacy(true);
                setCurrentPage(1);
              }}
              className={`font-semibold rounded-sm text-black  p-2 transition-all ${
                isPharmacy ? "bg-[#187498] text-white" : ""
              }`}
            >
              <p>Pharmacy</p>
            </button>
          </div>
        </div>
      )}
      {currentuserContexxt.currentUserData?.hospitals[selectedHospitalIndex]
        .municipal_tax_data && (
        <div className="flex flex-col gap-y-2 mt-2 ml-10">
          <hr className="w-96 border-slate-400" />

          <div className="flex gap-x-2 font-pop font-medium ">
            {generalRefundCategories.map((category, index) => {
              return (
                <button
                  onClick={() => {
                    setSelectedCategoryIndex(index);
                    setCurrentPage(1);
                  }}
                  className={`font-semibold rounded-sm text-black  p-2 transition-all capitalize ${
                    selectedCategoryIndex === index
                      ? "bg-[#187498] text-white"
                      : ""
                  }`}
                >
                  <p>{category}</p>
                </button>
              );
            })}
          </div>
        </div>
      )}
      {
        <Header2
          inputPlaceholder={"Rechercher dans ce tableau"}
          onInputChange={function (text: string): void {
            setSearchedText(text);
          }}
          handlePrint={handlePrint}
        />
      }
      <div className="flex ml-10 mb-4 ">
        <span className="font-semibold">Total : </span>
        <span>
          {data?.data
            .filter(
              (d, index) => selected.length === 0 || selected.includes(d.id)
            )
            .reduce((acc, item) => {
              return acc + item.revenue;
            }, 0)}
        </span>
      </div>
      {data === null ? (
        // center loading
        //center
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress thickness={6} sx={{ color: "#0B63F8" }} />
        </div>
      ) : (
        <Table
          style={{
            backgroundColor: "white",
            marginRight: "40px",
            marginLeft: "40px",
            width: "95.5%",
          }}
        >
          <MHeader
            titles={titles}
            withActions={true}
            onCheckClick={() => {
              if (selected.length === data?.data.length) {
                setSelected([]);
              } else {
                setSelected(data?.data.map((item) => item.id) || []);
              }
            }}
            isAllSelected={
              data &&
              data!.data.length !== 0 &&
              selected.length === data?.data.length
            }
          />
          <TableBody>
            {data!.data.map((versement, index) => (
              <TableRow key={index}>
                <TableCell size="small">
                  <Checkbox
                    checked={selected.includes(versement.id)}
                    onChange={() => {
                      if (selected.includes(versement.id)) {
                        setSelected(
                          selected.filter((item) => item !== versement.id)
                        );
                      } else {
                        setSelected([...selected, versement.id]);
                      }
                    }}
                  />
                </TableCell>
                <MTableCell label={hospitalName} isTitle={false} />
                <MTableCell label={`${hospitalBankAccount}`} isTitle={false} />
                <MTableCell label={`${versement.start}`} isTitle={false} />
                <MTableCell label={`${versement.end}`} isTitle={false} />
                <MTableCell label={`${versement.revenue}`} isTitle={false} />
                <MTableCell
                  label={
                    <button
                      onClick={() => {
                        alert(versement.date);
                        setHadlingPaymentDate(versement.date);
                      }}
                      className=" bg-[#187498] rounded text-white font-medium shadow-sm px-2 py-1 transition-all hover:scale-105"
                    >
                      Effectuer le versement
                    </button>
                  }
                  isTitle={false}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {data && (
        <Pagination
          currentPage={currentPage}
          totalPages={data!.total_pages}
          onPageChange={function (page: number): void {
            setCurrentPage(page);
          }}
        />
      )}
      <div ref={componentRef}>
        <PrintList
          centerName={
            currentuserContexxt.currentUserData!.hospitals[
              selectedHospitalIndex
            ].name
          }
          title={"ÉTAT DE VERSEMENT"}
          showRegisseur={true}
          titles={titles.map((title) => title.label)}
          afterTable={
            // total
            <div className="flex mb-4 ">
              <span className="font-semibold">Total : </span>
              <span>
                {data?.data
                  .filter(
                    (d, index) =>
                      selected.length === 0 || selected.includes(d.id)
                  )
                  .reduce((acc, item) => {
                    return acc + item.revenue;
                  }, 0)}
              </span>
            </div>
          }
          data={
            data?.data
              .filter(
                (versement) =>
                  selected.length === 0 || selected.includes(versement.id)
              )
              .map((versement, index) => {
                return [
                  hospitalName,
                  hospitalBankAccount,
                  versement.start,
                  versement.end,
                  versement.revenue,
                ];
              }) ?? []
          }
        />
      </div>
    </div>
  );
};

export default VersementNotPayed;

function CheckRefuseActions({
  onClick,
}: {
  onClick: (value: boolean) => void;
}) {
  return (
    <TableCell>
      <div className="flex flex-row gap-x-5">
        <svg
          onClick={() => {
            onClick(true);
          }}
          className="w-7 h-7 hover:scale-110 transition-all cursor-pointer items-center"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
              stroke="#3a9933"
              stroke-width="1.5"
            ></path>{" "}
            <path
              d="M8.5 12.5L10.5 14.5L15.5 9.5"
              stroke="#3a9933"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>{" "}
          </g>
        </svg>
        <svg
          onClick={() => {
            onClick(false);
          }}
          className="w-7 h-7 hover:scale-110 transition-all cursor-pointer items-center"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              d="M12.9998 8L6 14L12.9998 21"
              stroke="#f25f5f"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>{" "}
            <path
              d="M6 14H28.9938C35.8768 14 41.7221 19.6204 41.9904 26.5C42.2739 33.7696 36.2671 40 28.9938 40H11.9984"
              stroke="#f25f5f"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>{" "}
          </g>
        </svg>
      </div>
    </TableCell>
  );
}
